<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6">
          <v-card-title class="text-center text-h4 mb-4">
            Создание нового пароля
          </v-card-title>

          <v-alert
            v-if="showAlert"
            type="error"
            variant="tonal"
            closable
            class="mb-4"
            @click:close="showAlert = false"
          >
            {{ errorMessage }}
          </v-alert>

          <v-form @submit.prevent="handleSubmit" ref="form">
            <v-text-field
              v-model="password"
              name="new-password"
              autocomplete="new-password"
              label="Пароль"
              type="password"
              variant="outlined"
              required
              :rules="passwordRules"
              class="mb-3"
            ></v-text-field>

            <v-text-field
              v-model="confirmPassword"
              name="confirm-password"
              autocomplete="new-password"
              label="Ещё раз пароль"
              type="password"
              variant="outlined"
              required
              :rules="confirmPasswordRules"
              class="mb-4"
            ></v-text-field>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              class="mb-4"
            >
              Изменить пароль
            </v-btn>

            <v-row justify="center" class="mt-4">
              <v-col cols="auto">
                <router-link to="/signin" class="text-primary text-decoration-none">
                  Вход
                </router-link>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient from "@/apiClient";

export default {
  data() {
    return {
      password: '',
      confirmPassword: '',
      showAlert: false,
      errorMessage: '',
      passwordRules: [
        v => !!v || 'Пароль обязателен',
        v => (v && v.length >= 8) || 'Пароль должен содержать минимум 8 символов',
        v => (v && /[A-Z]/.test(v)) || 'Пароль должен содержать заглавную букву',
        v => (v && /[a-z]/.test(v)) || 'Пароль должен содержать строчную букву',
        v => (v && /\d/.test(v)) || 'Пароль должен содержать цифру'
      ],
      confirmPasswordRules: [
        v => !!v || 'Подтверждение пароля обязательно',
        v => v === this.password || 'Пароли не совпадают',
      ],
    };
  },
  methods: {
    handleSubmit() {
      const resetPasswordData = {
        new_password: this.password,
        confirm_password: this.confirmPassword,
        token: this.$route.params.token
      };
      apiClient.post('/reset-password', resetPasswordData)
          .then(response => {
            if (response.status === 200) {
              this.$router.push('/password-changed');
            } else {
              this.showError('Ошибка изменения пароля, попробуйте ещё раз');
            }
          })
          .catch(error => {
            const message = error.response && error.response.data && error.response.data.message;
            this.showError(message || 'Ошибка изменения пароля, попробуйте ещё раз');
          });
    },
    showError(errorMessage) {
      this.errorMessage = errorMessage;
      this.showAlert = true;
    }
  },
  mounted() {
    // Vuetify validation is handled automatically
  }
};
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>
